import { Card, CardActions, CardContent } from "@mui/material";
import styled from "styled-components";

export const CardListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--space-4);
  padding: var(--space-4) 0 var(--space-8);

  @media screen and (max-width: 1260px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 670px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-4);
  background: var(--card);
  border: var(--border-w) solid var(--ink);
  border-radius: var(--radius-xl);
  box-shadow: 0 var(--lip) 0 var(--line-strong);

  @media screen and (max-width: 800px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  transition: transform var(--dur-base) var(--ease-bounce);

  @media (hover: hover) {
    &:hover {
      transform: translateY(-2px) rotate(-0.5deg);
    }
  }
`;

export const StyledCardContent = styled(CardContent)`
  flex: 1;
  font-family: var(--font-display);
  font-weight: 600;
`;

export const StyledCardActions = styled(CardActions)`
  flex-wrap: wrap;
  gap: var(--space-2);

  > * {
    margin-left: 0;
  }
`;
